import AccountsPage from './pages/accounts.page';
import CalendarPage2 from './pages/calendar2.page';
import ChartsPage from './pages/charts.page';
import ClientsListPage from './pages/clients.page';
import ContactInfoPage from './pages/contactInfo.page';
import GiftsPage from './pages/gifts.page';
import DaemonsPage from './pages/daemons.page';
import LettersPage from './pages/letters.page';
import LoginPage from './pages/login.page';
import ProfilePage from './pages/profile.page';
import MenuPage from './pages/menu.page';
import ReportArchivesList from './pages/report-achives-list';
import ReportsArchiveDetailPage from './pages/reports-archive-detail.page';
import ReportsPage from './pages/reports.page';
import StaffPage from './pages/staff.page';
import StatisticsPage from './pages/statistics.page';
import TransfersPage from './pages/transfers.page';
import PayersPage from './pages/payers2.page';
import { ACCESS_LEVEL } from './store/auth/auth.constants';
import HomePage from './pages/home';
import DashboardPage from './pages/dashboard.page';
import ProxyPage from './pages/proxies.page';
import CredentialsPage from './components/menu/creds-list/creds-list';
import generalProfilePage from './pages/general-profile.page';
import chatsPage from './pages/chats.page';
import ShareLinkPage from './pages/share-link.page';

export const routes = [
  {
    path: '',
    redirectTo: '/login'
  },
  {
    path: '/login',
    component: LoginPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return true;
      }

      if (store.auth.accessLevel === ACCESS_LEVEL.account_manager ||
        store.auth.accessLevel === ACCESS_LEVEL.observer ||
        store.auth.accessLevel === ACCESS_LEVEL.visor
      ) {
        return navigation.redirectTo('/accounts');
      }

      return navigation.redirectTo('/reports');
    }
  },
  {
    path: '/menu',
    component: MenuPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/profile',
    component: ProfilePage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/proxies',
    component: ProxyPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }
      return true;
    }
  },
  {
    path: '/reports',
    component: ReportsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (store.auth.accessLevel === ACCESS_LEVEL.account_manager ||
        store.auth.accessLevel === ACCESS_LEVEL.observer ||
        store.auth.accessLevel === ACCESS_LEVEL.visor
      ) {
        return navigation.redirectTo('/accounts');
      }

      if (!store.auth.canShow.reports) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions } = route.context;

      actions.reportsActions.fetchEmptyReports();

      return true;
    }
  },
  {
    path: '/accounts',
    component: AccountsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.accounts) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions } = route.context;

      actions.accountsActions.fetchAccounts();

      return true;
    }
  },
  {
    path: '/daemons',
    component: DaemonsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.daemons) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions } = route.context;
      actions.daemonsActions.fetchDaemons();

      return true;
    }
  },
  {
    path: '/credentials',
    component: CredentialsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.credentials) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/letters',
    component: LettersPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.letters) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/finances',
    component: StatisticsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.statistics) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions } = route.context;

      actions.statisticsActions.fetchEmptyStats();

      return true;
    }
  },
  {
    path: '/staff',
    component: StaffPage,
    async willResolve(route) {
      const { actions } = route.context;

      actions.staffActions.fetch();

      return true;
    },
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.staff) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/transfers',
    component: TransfersPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }
      if (!store.auth.canShow.transfers) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/clients',
    component: ClientsListPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.clientsList) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/home',
    component: HomePage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.home) {
        return navigation.redirectTo('/login');
      }
      return true;
    },
    async willResolve(route) {
      const { actions } = route.context;
      actions.homeActions.fetch();
      return true;
    }
  },
  {
    path: '/dashboard',
    component: DashboardPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.dashboard) {
        return navigation.redirectTo('/login');
      }
      return true;
    },
    async willResolve(route) {
      const { actions } = route.context;
      actions.dashboardActions.fetchDashboard();
      return true;
    }
  },
  {
    path: '/calendar2',
    component: CalendarPage2,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.calendar2) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
  },
  {
    path: '/charts',
    component: ChartsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/archives',
    component: ReportArchivesList,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.archives) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions } = route.context;

      actions.reportArchivesActions.fetch();

      return true;
    }
  },
  {
    path: '/archives/:id',
    component: ReportsArchiveDetailPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.archives) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions, store } = route.context;

      if (!store.reportArchives.meta.loaded) {
        actions.reportArchivesActions.fetchById(route.params.id);
      }

      return true;
    }
  },
  {
    path: '/contactInfo',
    component: ContactInfoPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.contactInfo) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions, store } = route.context;

      if (!store.contactInfo.meta.loaded) {
        actions.contactInfoActions.fetchContactInfo();
      }

      return true;
    }
  },
  {
    path: '/gifts',
    component: GiftsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.gifts) {
        return navigation.redirectTo('/login');
      }

      return true;
    },
    async willResolve(route) {
      const { actions, store } = route.context;

      if (!store.gifts.meta.loaded) {
        actions.giftsActions.fetchGifts();
      }

      return true;
    }
  },
  {
    path: '/payers',
    component: PayersPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.payers) {
        return navigation.redirectTo('/login');
      }

      return true;
    }
  },
  {
    path: '/general',
    component: generalProfilePage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.general) {
        return navigation.redirectTo('/login');
      }

      return true;
    },

    async willResolve(route) {
      const { actions } = route.context;

      actions.generalProfileActions.fetchGeneralProfiles();

      return true;
    }
  },
  {
    path: '/chats',
    component: chatsPage,
    canActivate(route, navigation) {
      const { store } = route.context;

      if (!store.auth.isLoggedId) {
        return navigation.redirectTo('/login');
      }

      if (!store.auth.canShow.chats) {
        return navigation.redirectTo('/login');
      }

      return true;
    },

    async willResolve(route) {
      const { actions, store } = route.context;
      await actions.chatsActions.fetchUserCredList();
      await actions.chatsActions.refreshAccounts(
        {
          'all': '',
          'index': '',
          'account_id': '',
          'name': '',
          'panels': [store.chats.selected_cred_id.label],
          'managers': [],
          'teamleads': [],
          'scouts': [],
          'operators': [],
          'account-managers': [],
          'levels': [],
          'nick': '',
          'email': ''
        },
        1,
        null,
        null,
        200,
        'active'
      );
      return true;
    }
  },
  {
    path: '/share_link/:id',
    component: ShareLinkPage,

    async willResolve(route) {
      const { actions, store } = route.context;

      if (!store.shareLinks.meta.loaded) {
        actions.shareLinksActions.fetchById(route.params.id);
      }

      return true;
    }
  },
];
